import { c as create_ssr_component, a as add_attribute, e as escape, f as each, v as validate_component, m as missing_component } from "./ssr.js";
import { B as Button, S as StdHeading, a as StdParagraph } from "./Button.js";
import { F as FinancingCard, R as Reviews, C as ContactUsSection } from "./FinancingCard.js";
const BorderedSection_svelte_svelte_type_style_lang = "";
const css$b = {
  code: ".bordered_section.svelte-iqo1ep{padding:5.4rem 8.8rem;border:0.3rem solid #f36d21;gap:1.1rem;display:flex;flex-direction:column;align-items:center;border-radius:4rem;width:100%;background-color:#fff}@media(max-width: 1000px){.bordered_section.svelte-iqo1ep{padding:0px;border:none}}@media(max-width: 820px){.bordered_section.svelte-iqo1ep{border-radius:0px}}",
  map: null
};
const BorderedSection = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  $$result.css.add(css$b);
  return `<div class="bordered_section svelte-iqo1ep">${slots.default ? slots.default({}) : ``} </div>`;
});
const ArrowRight = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { size = "1em" } = $$props;
  let { width = size } = $$props;
  let { height = size } = $$props;
  let { color = "currentColor" } = $$props;
  let { viewBox = "0 0 24 24" } = $$props;
  let { ariaLabel = void 0 } = $$props;
  let { ariaHidden = void 0 } = $$props;
  let { title = void 0 } = $$props;
  let { desc = void 0 } = $$props;
  let { class: className = void 0 } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.width === void 0 && $$bindings.width && width !== void 0)
    $$bindings.width(width);
  if ($$props.height === void 0 && $$bindings.height && height !== void 0)
    $$bindings.height(height);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.viewBox === void 0 && $$bindings.viewBox && viewBox !== void 0)
    $$bindings.viewBox(viewBox);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0)
    $$bindings.ariaLabel(ariaLabel);
  if ($$props.ariaHidden === void 0 && $$bindings.ariaHidden && ariaHidden !== void 0)
    $$bindings.ariaHidden(ariaHidden);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0)
    $$bindings.desc(desc);
  if ($$props.class === void 0 && $$bindings.class && className !== void 0)
    $$bindings.class(className);
  return `<svg${add_attribute("viewBox", viewBox, 0)}${add_attribute("width", width, 0)}${add_attribute("height", height, 0)}${add_attribute("class", className, 0)}${add_attribute("aria-label", ariaLabel, 0)}${add_attribute("aria-hidden", ariaHidden, 0)}>${desc ? `<desc>${escape(desc)}</desc>` : ``}${title ? `<title>${escape(title)}</title>` : ``}<path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"${add_attribute("fill", color, 0)}></path></svg>`;
});
const Roadmap_svelte_svelte_type_style_lang = "";
const css$a = {
  code: ".roadmap.svelte-kwsrbl{display:flex;flex-direction:column;gap:1rem;width:100%;margin-top:2rem}.stage.svelte-kwsrbl{position:relative;display:flex;align-items:center;width:100%;justify-content:space-between;padding:2rem 2rem;border-radius:2.6rem}@media(max-width: 500px){.stage.svelte-kwsrbl{padding:20px 10px}}.orange.svelte-kwsrbl{background-color:#f36d21}.blue.svelte-kwsrbl{background-color:#0e76bc}.task.svelte-kwsrbl{display:flex;flex-direction:column;align-items:center;width:11rem}.task_icon.svelte-kwsrbl{font-size:4rem}.task_text.svelte-kwsrbl{text-align:center;font-family:Inter;font-size:1.4rem;font-style:normal;font-weight:600;line-height:normal;text-transform:uppercase}@media(max-width: 500px){.task_text.svelte-kwsrbl{font-size:10px}}.arrow.svelte-kwsrbl{font-size:4rem}",
  map: null
};
const Roadmap = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { stages } = $$props;
  if ($$props.stages === void 0 && $$bindings.stages && stages !== void 0)
    $$bindings.stages(stages);
  $$result.css.add(css$a);
  return ` <div class="roadmap svelte-kwsrbl">${each(stages, (tasks_of_stage, i1) => {
    return `<div class="${[
      "stage svelte-kwsrbl",
      (i1 % 2 === 0 ? "orange" : "") + " " + (i1 % 2 === 1 ? "blue" : "")
    ].join(" ").trim()}">${each(tasks_of_stage, (task, i2) => {
      return `<div class="task svelte-kwsrbl"><div class="task_icon svelte-kwsrbl">${`${validate_component(task.icon || missing_component, "svelte:component").$$render($$result, { size: "3rem" }, {}, {})}`}</div> <div class="task_text svelte-kwsrbl">${escape(task.text)} </div></div> ${i2 !== tasks_of_stage.length - 1 ? `<div class="arrow svelte-kwsrbl">${validate_component(ArrowRight, "ArrowRight").$$render($$result, {}, {}, {})} </div>` : ``}`;
    })}</div> `;
  })} </div>`;
});
const FridgeMagnet = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { color = "#F36D21" } = $$props;
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  return `<svg width="16.6rem" height="1.4rem" viewBox="0 0 166 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.25586 0.0859375C3.52794 0.0859375 0.505859 3.10802 0.505859 6.83594C0.505859 10.5639 3.52794 13.5859 7.25586 13.5859H158.756C162.484 13.5859 165.506 10.5639 165.506 6.83594C165.506 3.10802 162.484 0.0859375 158.756 0.0859375H7.25586ZM24.0892 1.58594C21.1897 1.58594 18.8392 3.93644 18.8392 6.83594C18.8392 9.73543 21.1897 12.0859 24.0892 12.0859H141.923C144.822 12.0859 147.173 9.73543 147.173 6.83594C147.173 3.93644 144.822 1.58594 141.923 1.58594H24.0892Z"${add_attribute("fill", color, 0)}></path></svg>`;
});
const ProgramCard_svelte_svelte_type_style_lang = "";
const css$9 = {
  code: ".program_card.svelte-wthado{display:flex;flex-direction:column;align-items:center;gap:2.5rem;padding:2.5rem;width:16rem;height:100%;border:0.3rem solid #0e76bc;border-radius:1.2rem;background-color:#fff;color:#15181c}.program_card.orange.svelte-wthado{border:0.3rem solid #f36d21}@media(max-width: 1024px){.program_card.svelte-wthado{width:100%;height:auto}}.program_title.svelte-wthado{text-align:center;height:2rem;font-weight:600;font-size:1.6rem}.values_wrapper.svelte-wthado{display:flex;flex-direction:column;align-items:center;gap:1rem;text-align:center;font-weight:500;margin-top:2.6rem}@media(max-width: 1024px){.values_wrapper.svelte-wthado{width:100%}}.value.svelte-wthado{font-size:1.6rem}.short_line.svelte-wthado{border-top:0.1rem solid #0e76bc;width:5rem}.short_line.orange.svelte-wthado{border-top:0.1rem solid #f36d21}@media(max-width: 1024px){.short_line.svelte-wthado{width:50%}}.icon.svelte-wthado{font-size:1.6rem;height:1.6rem;width:1.6rem;font-weight:700}.button_wrapper.svelte-wthado{margin-top:auto}.fridge_magnet.svelte-wthado{width:100%;display:flex;justify-content:center;align-items:center}",
  map: null
};
const ProgramCard = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { program } = $$props;
  let { has_button = true } = $$props;
  let { color = "blue" } = $$props;
  let { show_price = true } = $$props;
  if ($$props.program === void 0 && $$bindings.program && program !== void 0)
    $$bindings.program(program);
  if ($$props.has_button === void 0 && $$bindings.has_button && has_button !== void 0)
    $$bindings.has_button(has_button);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.show_price === void 0 && $$bindings.show_price && show_price !== void 0)
    $$bindings.show_price(show_price);
  $$result.css.add(css$9);
  return `<div class="${"program_card " + escape(color, true) + " svelte-wthado"}"><div class="fridge_magnet svelte-wthado">${color === "blue" ? `${validate_component(FridgeMagnet, "FridgeMagnet").$$render($$result, { color: "#0E76BC" }, {}, {})}` : `${validate_component(FridgeMagnet, "FridgeMagnet").$$render($$result, {}, {}, {})}`}</div> <div class="program_title svelte-wthado">${escape(program.title)}</div> <div class="values_wrapper svelte-wthado">${each(Object.values(program), (value, i) => {
    return `${i !== 0 ? `<div class="value svelte-wthado">${typeof value == "number" && value.toString().length > 3 ? ` ${show_price ? `$${escape(value.toLocaleString(void 0, { minimumFractionDigits: 2 }))}` : ``}` : `${typeof value === "number" ? `${escape(value)}hrs
               ` : `${typeof value === "string" ? `${escape(value)}` : ``}`}`}</div> ${i !== Object.values(program).length - 1 ? `<div class="${"short_line " + escape(color, true) + " svelte-wthado"}"></div>` : ``}` : ``}`;
  })}</div> ${has_button ? `<div class="button_wrapper svelte-wthado">${validate_component(Button, "Button").$$render($$result, { href: "/contact-us" }, {}, {
    default: () => {
      return `ENROLL`;
    }
  })}</div>` : ``} </div>`;
});
const ProgramPricing_svelte_svelte_type_style_lang = "";
const css$8 = {
  code: ".program_pricing.svelte-djb67s{position:relative;display:flex;flex-direction:column;justify-content:center;gap:1rem;color:#15181c;font-weight:500;height:44rem}@media(max-width: 1024px){.program_pricing.svelte-djb67s{position:static;height:auto;width:100%}}.line.svelte-djb67s{border-top:0.1rem solid #0e76bc}.row.svelte-djb67s{font-size:1.6rem;font-weight:600}.program_cards_wrapper.svelte-djb67s{position:absolute;display:flex;height:100%;gap:5rem;left:30rem}@media(max-width: 1024px){.program_cards_wrapper.svelte-djb67s{position:static;padding-top:25px;height:auto;flex-direction:column;align-items:center;gap:25px}}",
  map: null
};
const ProgramPricing = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let programs = [
    {
      title: "Sport Pilot",
      aircraft_rental_hours: 20,
      flight_instruction_hours: 15,
      ground_instruction_hours: 10,
      included: "Pilot Kit",
      total_cost: 5543.33
    },
    {
      title: "Private Pilot",
      aircraft_rental_hours: 40,
      flight_instruction_hours: 25,
      ground_instruction_hours: 10,
      included: "Pilot Kit",
      total_cost: 12795.98
    },
    {
      title: "Instrument Rating",
      aircraft_rental_hours: 20,
      flight_instruction_hours: 15,
      ground_instruction_hours: 10,
      included: "Foreflight",
      total_cost: 7264.37
    },
    {
      title: "Commercial SEL",
      aircraft_rental_hours: 25,
      flight_instruction_hours: 25,
      ground_instruction_hours: 10,
      included: "N/A",
      total_cost: 9574.35
    },
    {
      title: "Multi-Engine Add-on",
      aircraft_rental_hours: 12,
      flight_instruction_hours: 10,
      ground_instruction_hours: 5,
      included: "CBT",
      total_cost: 5561.43
    }
  ];
  $$result.css.add(css$8);
  return `<div class="program_pricing svelte-djb67s"><div class="row svelte-djb67s" data-svelte-h="svelte-1mdu9h8">Aircraft Rental hours</div> <div class="line svelte-djb67s"></div> <div class="row svelte-djb67s" data-svelte-h="svelte-190k3f2">Flight Instruction hours</div> <div class="line svelte-djb67s"></div> <div class="row svelte-djb67s" data-svelte-h="svelte-1lbnm1t">Ground Instruction hours</div> <div class="line svelte-djb67s"></div> <div class="row svelte-djb67s" data-svelte-h="svelte-1jvgozl">Included</div> <div class="line svelte-djb67s"></div> <div class="row svelte-djb67s" data-svelte-h="svelte-63j7g9">Total program cost (USD)</div> <div class="program_cards_wrapper svelte-djb67s">${each(programs, (program) => {
    return `${validate_component(ProgramCard, "ProgramCard").$$render($$result, { program }, {}, {})}`;
  })}</div> </div>`;
});
const Segment_svelte_svelte_type_style_lang = "";
const css$7 = {
  code: ".segment.svelte-15ovexc{display:flex;padding:1rem 2.1rem;align-items:center;gap:1.5rem;border-radius:8.4rem;border:0.3rem solid #fff;color:#fff;font-size:2rem;font-weight:600}.left_icon.svelte-15ovexc{font-size:2.4rem}",
  map: null
};
const Segment = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { icon } = $$props;
  if ($$props.icon === void 0 && $$bindings.icon && icon !== void 0)
    $$bindings.icon(icon);
  $$result.css.add(css$7);
  return `<div class="segment svelte-15ovexc"><div class="left_icon svelte-15ovexc">${validate_component(icon || missing_component, "svelte:component").$$render($$result, {}, {}, {})}</div> ${slots.default ? slots.default({}) : ``} </div>`;
});
const RentalRates_svelte_svelte_type_style_lang = "";
const css$6 = {
  code: ".program_pricing.svelte-fk856e{position:relative;display:flex;flex-direction:column;justify-content:center;gap:1rem;color:#15181c;font-weight:500;height:36rem;overflow-x:auto}@media(max-width: 1024px){.program_pricing.svelte-fk856e{position:static;height:auto;overflow-x:hidden}}.line.svelte-fk856e{border-top:0.1rem solid #f36d21}.row.svelte-fk856e{font-size:1.6rem;font-weight:600}.program_cards_wrapper.svelte-fk856e{position:absolute;display:flex;height:100%;gap:5rem;left:26rem}@media(max-width: 1024px){.program_cards_wrapper.svelte-fk856e{padding-top:25px;position:static;flex-direction:column;align-items:center;height:auto;gap:25px}}.program_card.svelte-fk856e{display:flex;flex-direction:column;align-items:center;gap:2.5rem;padding:2.5rem 0.8rem;width:18rem;height:100%;border:0.3rem solid #f36d21;border-radius:1.2rem;background-color:#fff}@media(max-width: 1024px){.program_card.svelte-fk856e{width:100%;height:auto}}.program_title.svelte-fk856e{text-align:center;height:2rem;font-weight:600;font-size:1.6rem}.plane_img.svelte-fk856e{width:100%}.values_wrapper.svelte-fk856e{display:flex;flex-direction:column;align-items:center;gap:1rem;text-align:center;font-weight:600;margin:auto;margin-bottom:3.8rem}@media(max-width: 1024px){.values_wrapper.svelte-fk856e{width:100%}}.value.svelte-fk856e{font-size:1.6rem}.short_line.svelte-fk856e{border-top:0.1rem solid #f36d21;width:5rem}@media(max-width: 1024px){.short_line.svelte-fk856e{width:50%}}.fridge_magnet.svelte-fk856e{width:80%;display:flex;justify-content:center;align-items:center}.first_row.svelte-fk856e{margin-top:14.1rem}@media(max-width: 1024px){.first_row.svelte-fk856e{margin-top:0}}",
  map: null
};
const RentalRates = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let planes = [
    {
      title: "The Tecnam P92 Eaglet",
      img: "/P92Eaglet.webp",
      imgHeight: 61,
      price1: 149,
      price2: 119,
      price3: 79
    },
    {
      title: "The Piper Cherokee 140",
      img: "/Cherokee140Piper.webp",
      imgHeight: 60,
      price1: 149,
      price2: 119,
      price3: 79
    },
    {
      title: "The Cessna 172",
      img: "/172Cessna.webp",
      imgHeight: 58,
      price1: 159,
      price2: 139,
      price3: 79
    },
    {
      title: "The Piper 100i",
      img: "/Pilot100iPiper.webp",
      imgHeight: 60,
      price1: 225,
      price2: 199,
      price3: 89
    },
    {
      title: "The Tecnam P2006t",
      img: "/P2006tTecnam.webp",
      imgHeight: 61,
      price1: 325,
      price2: 299,
      price3: 99
    }
  ];
  $$result.css.add(css$6);
  return `<div class="program_pricing svelte-fk856e"><div class="row first_row svelte-fk856e" data-svelte-h="svelte-qdomhx">Hourly Rental Rate</div> <div class="line svelte-fk856e"></div> <div class="row svelte-fk856e" data-svelte-h="svelte-8necq6">Block Rate (50+ hrs)</div> <div class="line svelte-fk856e"></div> <div class="row svelte-fk856e" data-svelte-h="svelte-gagz73">Instruction Rate</div> <div class="program_cards_wrapper svelte-fk856e">${each(planes, (plane) => {
    return `<div class="program_card svelte-fk856e"><div class="fridge_magnet svelte-fk856e">${validate_component(FridgeMagnet, "FridgeMagnet").$$render($$result, {}, {}, {})}</div> <div class="program_title svelte-fk856e">${escape(plane.title)}</div> <img${add_attribute("src", plane.img, 0)} class="plane_img svelte-fk856e" alt="Plane Model" style="${"width: 159px; height: " + escape(plane.imgHeight, true) + "px;"}"> <div class="values_wrapper svelte-fk856e"><div class="value svelte-fk856e">$${escape(plane.price1)}/hr</div> <div class="short_line svelte-fk856e"></div> <div class="value svelte-fk856e">$${escape(plane.price2)}/hr</div> <div class="short_line svelte-fk856e"></div> <div class="value svelte-fk856e">$${escape(plane.price3)}/hr
          </div></div> </div>`;
  })}</div> </div>`;
});
const Plus = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { size = "1em" } = $$props;
  let { width = size } = $$props;
  let { height = size } = $$props;
  let { color = "currentColor" } = $$props;
  let { viewBox = "0 0 24 24" } = $$props;
  let { ariaLabel = void 0 } = $$props;
  let { ariaHidden = void 0 } = $$props;
  let { title = void 0 } = $$props;
  let { desc = void 0 } = $$props;
  let { class: className = void 0 } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.width === void 0 && $$bindings.width && width !== void 0)
    $$bindings.width(width);
  if ($$props.height === void 0 && $$bindings.height && height !== void 0)
    $$bindings.height(height);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.viewBox === void 0 && $$bindings.viewBox && viewBox !== void 0)
    $$bindings.viewBox(viewBox);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0)
    $$bindings.ariaLabel(ariaLabel);
  if ($$props.ariaHidden === void 0 && $$bindings.ariaHidden && ariaHidden !== void 0)
    $$bindings.ariaHidden(ariaHidden);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0)
    $$bindings.desc(desc);
  if ($$props.class === void 0 && $$bindings.class && className !== void 0)
    $$bindings.class(className);
  return `<svg${add_attribute("viewBox", viewBox, 0)}${add_attribute("width", width, 0)}${add_attribute("height", height, 0)}${add_attribute("class", className, 0)}${add_attribute("aria-label", ariaLabel, 0)}${add_attribute("aria-hidden", ariaHidden, 0)}>${desc ? `<desc>${escape(desc)}</desc>` : ``}${title ? `<title>${escape(title)}</title>` : ``}<path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"${add_attribute("fill", color, 0)}></path></svg>`;
});
const Equal = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { size = "1em" } = $$props;
  let { width = size } = $$props;
  let { height = size } = $$props;
  let { color = "currentColor" } = $$props;
  let { viewBox = "0 0 24 24" } = $$props;
  let { ariaLabel = void 0 } = $$props;
  let { ariaHidden = void 0 } = $$props;
  let { title = void 0 } = $$props;
  let { desc = void 0 } = $$props;
  let { class: className = void 0 } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.width === void 0 && $$bindings.width && width !== void 0)
    $$bindings.width(width);
  if ($$props.height === void 0 && $$bindings.height && height !== void 0)
    $$bindings.height(height);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.viewBox === void 0 && $$bindings.viewBox && viewBox !== void 0)
    $$bindings.viewBox(viewBox);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0)
    $$bindings.ariaLabel(ariaLabel);
  if ($$props.ariaHidden === void 0 && $$bindings.ariaHidden && ariaHidden !== void 0)
    $$bindings.ariaHidden(ariaHidden);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0)
    $$bindings.desc(desc);
  if ($$props.class === void 0 && $$bindings.class && className !== void 0)
    $$bindings.class(className);
  return `<svg${add_attribute("viewBox", viewBox, 0)}${add_attribute("width", width, 0)}${add_attribute("height", height, 0)}${add_attribute("class", className, 0)}${add_attribute("aria-label", ariaLabel, 0)}${add_attribute("aria-hidden", ariaHidden, 0)}>${desc ? `<desc>${escape(desc)}</desc>` : ``}${title ? `<title>${escape(title)}</title>` : ``}<path d="M19,10H5V8H19V10M19,16H5V14H19V16Z"${add_attribute("fill", color, 0)}></path></svg>`;
});
const ProgramCardSmall_svelte_svelte_type_style_lang = "";
const css$5 = {
  code: ".program_card.svelte-x0vh9v{display:flex;flex-direction:column;align-items:center;gap:2.5rem;padding:2.5rem;border:0.3rem solid #0e76bc;border-radius:1.2rem;background-color:#fff;color:#15181c;width:29rem;height:15rem}.program_card.orange.svelte-x0vh9v{border:0.3rem solid #f36d21}.clean.svelte-x0vh9v{justify-content:center}.program_title.svelte-x0vh9v{text-align:center;height:2rem;font-weight:600;font-size:1.6rem}.values_wrapper.svelte-x0vh9v{display:flex;flex-direction:column;align-items:center;gap:1rem;text-align:center;font-weight:500;margin-top:0.3rem}.short_line.svelte-x0vh9v{border-top:0.1rem solid #0e76bc;width:5rem}.short_line.orange.svelte-x0vh9v{border-top:0.1rem solid #f36d21}.icon.svelte-x0vh9v{font-size:1.6rem;height:1.6rem;width:1.6rem;font-weight:700}.button_wrapper.svelte-x0vh9v{margin-top:auto}.fridge_magnet.svelte-x0vh9v{width:100%;display:flex;justify-content:center;align-items:center}.cost.svelte-x0vh9v{font-weight:500;font-size:1.6rem}",
  map: null
};
const ProgramCardSmall = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { program } = $$props;
  let { color = "blue" } = $$props;
  let { show_price = true } = $$props;
  if ($$props.program === void 0 && $$bindings.program && program !== void 0)
    $$bindings.program(program);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.show_price === void 0 && $$bindings.show_price && show_price !== void 0)
    $$bindings.show_price(show_price);
  $$result.css.add(css$5);
  return `<div class="${[
    "program_card " + escape(color, true) + " svelte-x0vh9v",
    !show_price ? "clean" : ""
  ].join(" ").trim()}"><div class="fridge_magnet svelte-x0vh9v">${color === "blue" ? `${validate_component(FridgeMagnet, "FridgeMagnet").$$render($$result, { color: "#0E76BC" }, {}, {})}` : `${validate_component(FridgeMagnet, "FridgeMagnet").$$render($$result, {}, {}, {})}`}</div> <div class="program_title svelte-x0vh9v">${escape(program.title)}</div> ${show_price ? `<div class="cost svelte-x0vh9v">$${escape(program.cost.toLocaleString(void 0, { minimumFractionDigits: 2 }))}</div>` : ``} </div>`;
});
const FullPackagePricing_svelte_svelte_type_style_lang = "";
const css$4 = {
  code: ".full_package_pricing.svelte-17pgb1w{position:relative;display:flex;flex-direction:column;padding:2.5rem 10rem;align-items:center;width:100%;gap:2rem;border-radius:2rem;overflow-x:auto}@media(max-width: 500px){.full_package_pricing.svelte-17pgb1w{align-items:flex-start;background-color:#f36d21}}.background.svelte-17pgb1w{position:absolute;height:100%;width:50%;z-index:-1;left:0;top:0}@media(max-width: 500px){.background.svelte-17pgb1w{width:100%}}.background.orange.svelte-17pgb1w{background-color:#f36d21;border-radius:2rem 0 0 2rem}.background.blue.svelte-17pgb1w{background-color:#0e76bc;left:50%;border-radius:0 2rem 2rem 0}.fridge_magnet.svelte-17pgb1w{width:100%;display:flex;justify-content:center;align-items:center}.main_heading.svelte-17pgb1w{margin-left:-0.7rem}.program_cards_wrapper.svelte-17pgb1w{display:flex;flex-direction:row;gap:2rem;overflow-x:auto}.plus_icon.svelte-17pgb1w{display:flex;justify-content:center;align-items:center;font-size:5rem}.plus_icon.larger.svelte-17pgb1w{font-size:6rem}.program_card.svelte-17pgb1w{display:flex;flex-direction:column;align-items:center;gap:2.5rem;padding:2.5rem;width:16rem;height:100%;border:0.3rem solid #0e76bc;border-radius:1.2rem;background-color:#fff;color:#15181c}.program_card.orange.svelte-17pgb1w{border:0.3rem solid #f36d21}.program_title.svelte-17pgb1w{text-align:center;height:2rem;font-weight:600;font-size:1.6rem}.values_wrapper.svelte-17pgb1w{display:flex;flex-direction:column;align-items:center;gap:1rem;text-align:center;font-weight:500;margin-top:2.6rem}.short_line.svelte-17pgb1w{border-top:0.1rem solid #0e76bc;width:5rem}.short_line.orange.svelte-17pgb1w{border-top:0.1rem solid #f36d21}.fridge_magnet.svelte-17pgb1w{width:100%;display:flex;justify-content:center;align-items:center}.value.svelte-17pgb1w{font-size:1.6rem}",
  map: null
};
const FullPackagePricing = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let description = {
    title: "Description",
    aircraft_rental_hours: "Rental Hours",
    flight_instruction_hours: "Instruction",
    ground_instruction_hours: "Ground",
    total_cost: "Total Cost"
  };
  let totals = {
    title: "All the Hours You Need",
    aircraft_rental_hours: 254,
    flight_instruction_hours: 70,
    ground_instruction_hours: 65,
    total_cost: 59415
  };
  let main_programs = [
    {
      title: "Private Pilot",
      aircraft_rental_hours: 40,
      flight_instruction_hours: 25,
      ground_instruction_hours: 10
    },
    {
      title: "Instrument Rating",
      aircraft_rental_hours: 20,
      flight_instruction_hours: 15,
      ground_instruction_hours: 10
    },
    {
      title: "Commercial SEL",
      aircraft_rental_hours: 25,
      flight_instruction_hours: 25,
      ground_instruction_hours: 10
    }
  ];
  let add_ons = [
    {
      title: "Certified Flight Instructor",
      cost: 8385
    },
    {
      title: "Commercial Multi-Engine",
      cost: 9346
    },
    {
      title: "Certified Flight Instructor Instrument",
      cost: 7035
    },
    {
      title: "Certified Flight Instructor Multi-Engine",
      cost: 9660
    },
    {
      title: "50 hours of Multi-Engine time building",
      cost: 16659.8
    },
    {
      title: "9 Months Housing (double Occupancy)",
      cost: 9e3
    }
  ];
  $$result.css.add(css$4);
  return `<div class="full_package_pricing svelte-17pgb1w"><div class="background orange svelte-17pgb1w"></div> <div class="background blue svelte-17pgb1w"></div> <div class="fridge_magnet svelte-17pgb1w">${validate_component(FridgeMagnet, "FridgeMagnet").$$render($$result, { color: "#FFFFFF" }, {}, {})}</div> <div class="main_heading svelte-17pgb1w">${validate_component(StdHeading, "StdHeading").$$render($$result, { color: "white", font_family: "Inter" }, {}, {
    default: () => {
      return `Commit to Your Aviation Career`;
    }
  })}</div> <div class="program_cards_wrapper svelte-17pgb1w"><div class="program_card svelte-17pgb1w"><div class="fridge_magnet svelte-17pgb1w">${validate_component(FridgeMagnet, "FridgeMagnet").$$render($$result, { color: "#0E76BC" }, {}, {})}</div> <div class="program_title svelte-17pgb1w">${escape(description.title)}</div> <div class="values_wrapper svelte-17pgb1w">${each(Object.values(description), (value, i) => {
    return `${i !== 0 ? `<div class="value svelte-17pgb1w">${escape(value)}</div> ${i !== Object.values(description).length - 1 ? `<div class="short_line svelte-17pgb1w"></div>` : ``}` : ``}`;
  })}</div></div> <div class="plus_icon svelte-17pgb1w">${validate_component(ArrowRight, "ArrowRight").$$render($$result, {}, {}, {})}</div> ${each(main_programs, (program, i) => {
    return `${validate_component(ProgramCard, "ProgramCard").$$render(
      $$result,
      {
        show_price: true,
        program,
        has_button: false,
        color: i < 2 ? "blue" : "orange"
      },
      {},
      {}
    )} ${i !== main_programs.length - 1 ? `<div class="plus_icon svelte-17pgb1w">${validate_component(Plus, "Plus").$$render($$result, {}, {}, {})} </div>` : ``}`;
  })} <div class="plus_icon svelte-17pgb1w">${validate_component(Equal, "Equal").$$render($$result, {}, {}, {})}</div> <div class="program_card orange svelte-17pgb1w"><div class="fridge_magnet svelte-17pgb1w">${validate_component(FridgeMagnet, "FridgeMagnet").$$render($$result, {}, {}, {})}</div> <div class="program_title svelte-17pgb1w">${escape(totals.title)}</div> <div class="values_wrapper svelte-17pgb1w">${each(Object.values(totals), (value, i) => {
    return `${i !== 0 ? `<div class="value svelte-17pgb1w">${value.toString().length > 3 ? `
                $${escape(value.toLocaleString(void 0, { minimumFractionDigits: 2 }))}` : `${typeof value === "number" ? `${escape(value)}hrs
                   ` : `${typeof value === "string" ? `${escape(value)}` : ``}`}`}</div> ${i !== Object.values(totals).length - 1 ? `<div class="short_line orange svelte-17pgb1w"></div>` : ``}` : ``}`;
  })}</div></div></div> <div class="plus_icon larger svelte-17pgb1w">${validate_component(Plus, "Plus").$$render($$result, {}, {}, {})}</div> ${validate_component(StdHeading, "StdHeading").$$render($$result, { color: "white", font_family: "Inter" }, {}, {
    default: () => {
      return `Add-Ons`;
    }
  })} <div class="program_cards_wrapper svelte-17pgb1w">${each(add_ons.slice(0, 3), (add_on, i) => {
    return `${validate_component(ProgramCardSmall, "ProgramCardSmall").$$render(
      $$result,
      {
        show_price: true,
        program: add_on,
        color: i !== 2 ? "blue" : "orange"
      },
      {},
      {}
    )}`;
  })}</div> <div class="program_cards_wrapper svelte-17pgb1w">${each(add_ons.slice(3, 6), (add_on, i) => {
    return `${validate_component(ProgramCardSmall, "ProgramCardSmall").$$render(
      $$result,
      {
        show_price: true,
        program: add_on,
        color: i !== 2 ? "blue" : "orange"
      },
      {},
      {}
    )}`;
  })}</div> </div>`;
});
const Minus = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { size = "1em" } = $$props;
  let { width = size } = $$props;
  let { height = size } = $$props;
  let { color = "currentColor" } = $$props;
  let { viewBox = "0 0 24 24" } = $$props;
  let { ariaLabel = void 0 } = $$props;
  let { ariaHidden = void 0 } = $$props;
  let { title = void 0 } = $$props;
  let { desc = void 0 } = $$props;
  let { class: className = void 0 } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.width === void 0 && $$bindings.width && width !== void 0)
    $$bindings.width(width);
  if ($$props.height === void 0 && $$bindings.height && height !== void 0)
    $$bindings.height(height);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.viewBox === void 0 && $$bindings.viewBox && viewBox !== void 0)
    $$bindings.viewBox(viewBox);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0)
    $$bindings.ariaLabel(ariaLabel);
  if ($$props.ariaHidden === void 0 && $$bindings.ariaHidden && ariaHidden !== void 0)
    $$bindings.ariaHidden(ariaHidden);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0)
    $$bindings.desc(desc);
  if ($$props.class === void 0 && $$bindings.class && className !== void 0)
    $$bindings.class(className);
  return `<svg${add_attribute("viewBox", viewBox, 0)}${add_attribute("width", width, 0)}${add_attribute("height", height, 0)}${add_attribute("class", className, 0)}${add_attribute("aria-label", ariaLabel, 0)}${add_attribute("aria-hidden", ariaHidden, 0)}>${desc ? `<desc>${escape(desc)}</desc>` : ``}${title ? `<title>${escape(title)}</title>` : ``}<path d="M19,13H5V11H19V13Z"${add_attribute("fill", color, 0)}></path></svg>`;
});
const FAQs_svelte_svelte_type_style_lang = "";
const css$3 = {
  code: ".faqs.svelte-1volead{padding:12rem 10rem;background-color:#0e76bc;display:flex;flex-direction:column;gap:3rem}@media(max-width: 800px){.faqs.svelte-1volead{padding:60px 20px}}.top_bar.svelte-1volead{display:flex;justify-content:space-between;align-items:center;border:0.3rem solid #fff;border-radius:2rem;padding:1.4rem 2rem}.top_bar.svelte-1volead:hover{background-color:#2683c2;cursor:pointer}.question.svelte-1volead{margin:0;padding:0;font-size:2rem;font-weight:500}@media(max-width: 500px){.question.svelte-1volead{font-size:16px}}.icon.svelte-1volead{font-size:30px;display:flex;justify-content:center;align-items:center}.answer.svelte-1volead{border-left:0.3rem solid #fff;border-right:0.3rem solid #fff;border-bottom:0.3rem solid #fff;border-radius:0 0 2rem 2rem;padding:4rem 5rem;margin-top:-2rem;white-space:pre-line}",
  map: null
};
const FAQs = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { faqs } = $$props;
  if ($$props.faqs === void 0 && $$bindings.faqs && faqs !== void 0)
    $$bindings.faqs(faqs);
  $$result.css.add(css$3);
  return `<div class="faqs svelte-1volead">${validate_component(StdHeading, "StdHeading").$$render(
    $$result,
    {
      color: "white",
      font_family: "Inter",
      size: "small"
    },
    {},
    {
      default: () => {
        return `FREQUENTLY ASKED QUESTIONS`;
      }
    }
  )} ${each(faqs, (faq) => {
    return `<div class="faq">  <div class="top_bar svelte-1volead"><h3 class="question svelte-1volead">${escape(faq.question)}</h3> <div class="icon svelte-1volead">${!faq.opened ? `${validate_component(Plus, "Plus").$$render($$result, { size: "3rem" }, {}, {})}` : `${validate_component(Minus, "Minus").$$render($$result, { size: "3rem" }, {}, {})}`} </div></div> ${faq.opened ? `<div class="answer svelte-1volead">${validate_component(StdParagraph, "StdParagraph").$$render($$result, {}, {}, {
      default: () => {
        return `<!-- HTML_TAG_START -->${faq.answer}<!-- HTML_TAG_END --> `;
      }
    })} </div>` : ``} </div>`;
  })} </div>`;
});
const DiscoveryFlightSection_svelte_svelte_type_style_lang = "";
const css$2 = {
  code: ".hero.svelte-1dc4vfx{width:100%;background-size:cover;background-repeat:no-repeat;padding:5rem 4rem;height:100vh}@media(max-width: 800px){.hero.svelte-1dc4vfx{height:min-content}}.discovery_flight_content.svelte-1dc4vfx{display:flex;justify-content:space-between;gap:5rem}@media(max-width: 800px){.discovery_flight_content.svelte-1dc4vfx{flex-direction:column}}.discover_flight_description.svelte-1dc4vfx{display:flex;flex-direction:column;gap:1rem;background-color:rgba(0,0,0,0.1);backdrop-filter:blur(20px);border-radius:4rem;padding:3.5rem 5rem;max-width:70rem}.discovery_button_wrapper.svelte-1dc4vfx{margin-left:auto}@media(max-width: 800px){.discovery_headings.svelte-1dc4vfx{display:flex;flex-direction:column;gap:25px}}",
  map: null
};
const DiscoveryFlightSection = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  $$result.css.add(css$2);
  return `<div class="hero svelte-1dc4vfx" style="background-image: url('/flying_next_to_clouds.webp');"><div id="discovery" class="discovery_flight_content svelte-1dc4vfx"><div class="discovery_headings svelte-1dc4vfx">${validate_component(StdHeading, "StdHeading").$$render(
    $$result,
    {
      size: "small",
      font_family: "Inter",
      color: "white"
    },
    {},
    {
      default: () => {
        return `DISCOVERY FLIGHT`;
      }
    }
  )} ${validate_component(StdHeading, "StdHeading").$$render(
    $$result,
    {
      size: "large",
      font_family: "Inter",
      color: "white"
    },
    {},
    {
      default: () => {
        return `KICK START YOUR AVIATION EXPERIENCE`;
      }
    }
  )}</div> <div class="discover_flight_description svelte-1dc4vfx">${validate_component(StdParagraph, "StdParagraph").$$render($$result, {}, {}, {
    default: () => {
      return `We offer a 1-hour discovery flight to give you the opportunity to
        experience taking to the air. A certified flight instructor will
        demonstrate preflight and flying techniques before you climb aboard,
        will taxi down the runway and before you know it, you are in the air!
        During the flight, you will have the opportunity to control the plane
        through the sky and try out several maneuvers before the pilot takes
        over again for landing. At the subsequent debriefing, guests pen their
        first logbook entry and review their performance.`;
    }
  })} <div class="discovery_button_wrapper svelte-1dc4vfx">${validate_component(Button, "Button").$$render($$result, { href: "/contact-us", color: "orange" }, {}, {
    default: () => {
      return `Book your Discovery Flight`;
    }
  })}</div></div></div> </div>`;
});
const FirstHeroContent_svelte_svelte_type_style_lang = "";
const css$1 = {
  code: '.hero_heading.svelte-1itj8xe{margin:0;padding:0;padding:1rem 0;font-size:4.6rem;font-family:"REM";text-transform:uppercase;line-height:5.4rem}@media(max-width: 800px){.hero_heading.svelte-1itj8xe{font-size:36px}}.hero_content.svelte-1itj8xe{padding:2rem;display:flex;flex-direction:column;gap:2rem;max-width:80rem;background-color:rgba(0,0,0,0.25);backdrop-filter:blur(20px);border-radius:0.5rem}.text_background.svelte-1itj8xe{padding:0 0.6rem}.orange_background.svelte-1itj8xe{background-color:#f36d21}.blue_background.svelte-1itj8xe{background-color:#0e76bc}.rounded.svelte-1itj8xe{border-radius:0.5rem}',
  map: null
};
const FirstHeroContent = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { h1 } = $$props;
  let { hero_paragraph_content } = $$props;
  if ($$props.h1 === void 0 && $$bindings.h1 && h1 !== void 0)
    $$bindings.h1(h1);
  if ($$props.hero_paragraph_content === void 0 && $$bindings.hero_paragraph_content && hero_paragraph_content !== void 0)
    $$bindings.hero_paragraph_content(hero_paragraph_content);
  $$result.css.add(css$1);
  return ` <h1 class="hero_heading svelte-1itj8xe"><span class="text_background orange_background rounded svelte-1itj8xe">${escape(h1.split(" ")[0])}</span> <span class="${"text_background " + escape("blue_background", true) + " rounded svelte-1itj8xe"}">${escape(h1.split(" ").slice(1).join(" "))}</span></h1> <div class="hero_content svelte-1itj8xe">${validate_component(StdParagraph, "StdParagraph").$$render($$result, {}, {}, {
    default: () => {
      return `<!-- HTML_TAG_START -->${hero_paragraph_content}<!-- HTML_TAG_END -->`;
    }
  })} </div>`;
});
const CurrencyUsd = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { size = "1em" } = $$props;
  let { width = size } = $$props;
  let { height = size } = $$props;
  let { color = "currentColor" } = $$props;
  let { viewBox = "0 0 24 24" } = $$props;
  let { ariaLabel = void 0 } = $$props;
  let { ariaHidden = void 0 } = $$props;
  let { title = void 0 } = $$props;
  let { desc = void 0 } = $$props;
  let { class: className = void 0 } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.width === void 0 && $$bindings.width && width !== void 0)
    $$bindings.width(width);
  if ($$props.height === void 0 && $$bindings.height && height !== void 0)
    $$bindings.height(height);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.viewBox === void 0 && $$bindings.viewBox && viewBox !== void 0)
    $$bindings.viewBox(viewBox);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0)
    $$bindings.ariaLabel(ariaLabel);
  if ($$props.ariaHidden === void 0 && $$bindings.ariaHidden && ariaHidden !== void 0)
    $$bindings.ariaHidden(ariaHidden);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0)
    $$bindings.desc(desc);
  if ($$props.class === void 0 && $$bindings.class && className !== void 0)
    $$bindings.class(className);
  return `<svg${add_attribute("viewBox", viewBox, 0)}${add_attribute("width", width, 0)}${add_attribute("height", height, 0)}${add_attribute("class", className, 0)}${add_attribute("aria-label", ariaLabel, 0)}${add_attribute("aria-hidden", ariaHidden, 0)}>${desc ? `<desc>${escape(desc)}</desc>` : ``}${title ? `<title>${escape(title)}</title>` : ``}<path d="M7,15H9C9,16.08 10.37,17 12,17C13.63,17 15,16.08 15,15C15,13.9 13.96,13.5 11.76,12.97C9.64,12.44 7,11.78 7,9C7,7.21 8.47,5.69 10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C10.37,7 9,7.92 9,9C9,10.1 10.04,10.5 12.24,11.03C14.36,11.56 17,12.22 17,15C17,16.79 15.53,18.31 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15Z"${add_attribute("fill", color, 0)}></path></svg>`;
});
const PlusThick = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { size = "1em" } = $$props;
  let { width = size } = $$props;
  let { height = size } = $$props;
  let { color = "currentColor" } = $$props;
  let { viewBox = "0 0 24 24" } = $$props;
  let { ariaLabel = void 0 } = $$props;
  let { ariaHidden = void 0 } = $$props;
  let { title = void 0 } = $$props;
  let { desc = void 0 } = $$props;
  let { class: className = void 0 } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.width === void 0 && $$bindings.width && width !== void 0)
    $$bindings.width(width);
  if ($$props.height === void 0 && $$bindings.height && height !== void 0)
    $$bindings.height(height);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.viewBox === void 0 && $$bindings.viewBox && viewBox !== void 0)
    $$bindings.viewBox(viewBox);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0)
    $$bindings.ariaLabel(ariaLabel);
  if ($$props.ariaHidden === void 0 && $$bindings.ariaHidden && ariaHidden !== void 0)
    $$bindings.ariaHidden(ariaHidden);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0)
    $$bindings.desc(desc);
  if ($$props.class === void 0 && $$bindings.class && className !== void 0)
    $$bindings.class(className);
  return `<svg${add_attribute("viewBox", viewBox, 0)}${add_attribute("width", width, 0)}${add_attribute("height", height, 0)}${add_attribute("class", className, 0)}${add_attribute("aria-label", ariaLabel, 0)}${add_attribute("aria-hidden", ariaHidden, 0)}>${desc ? `<desc>${escape(desc)}</desc>` : ``}${title ? `<title>${escape(title)}</title>` : ``}<path d="M20 14H14V20H10V14H4V10H10V4H14V10H20V14Z"${add_attribute("fill", color, 0)}></path></svg>`;
});
const TextBoxEditOutline = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { size = "1em" } = $$props;
  let { width = size } = $$props;
  let { height = size } = $$props;
  let { color = "currentColor" } = $$props;
  let { viewBox = "0 0 24 24" } = $$props;
  let { ariaLabel = void 0 } = $$props;
  let { ariaHidden = void 0 } = $$props;
  let { title = void 0 } = $$props;
  let { desc = void 0 } = $$props;
  let { class: className = void 0 } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.width === void 0 && $$bindings.width && width !== void 0)
    $$bindings.width(width);
  if ($$props.height === void 0 && $$bindings.height && height !== void 0)
    $$bindings.height(height);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.viewBox === void 0 && $$bindings.viewBox && viewBox !== void 0)
    $$bindings.viewBox(viewBox);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0)
    $$bindings.ariaLabel(ariaLabel);
  if ($$props.ariaHidden === void 0 && $$bindings.ariaHidden && ariaHidden !== void 0)
    $$bindings.ariaHidden(ariaHidden);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0)
    $$bindings.desc(desc);
  if ($$props.class === void 0 && $$bindings.class && className !== void 0)
    $$bindings.class(className);
  return `<svg${add_attribute("viewBox", viewBox, 0)}${add_attribute("width", width, 0)}${add_attribute("height", height, 0)}${add_attribute("class", className, 0)}${add_attribute("aria-label", ariaLabel, 0)}${add_attribute("aria-hidden", ariaHidden, 0)}>${desc ? `<desc>${escape(desc)}</desc>` : ``}${title ? `<title>${escape(title)}</title>` : ``}<path d="M10 21H5C3.89 21 3 20.11 3 19V5C3 3.89 3.89 3 5 3H19C20.11 3 21 3.89 21 5V10.33C20.7 10.21 20.37 10.14 20.04 10.14C19.67 10.14 19.32 10.22 19 10.37V5H5V19H10.11L10 19.11V21M7 9H17V7H7V9M7 17H12.11L14 15.12V15H7V17M7 13H16.12L17 12.12V11H7V13M21.7 13.58L20.42 12.3C20.21 12.09 19.86 12.09 19.65 12.3L18.65 13.3L20.7 15.35L21.7 14.35C21.91 14.14 21.91 13.79 21.7 13.58M12 22H14.06L20.11 15.93L18.06 13.88L12 19.94V22Z"${add_attribute("fill", color, 0)}></path></svg>`;
});
const Shield = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { size = "1em" } = $$props;
  let { width = size } = $$props;
  let { height = size } = $$props;
  let { color = "currentColor" } = $$props;
  let { viewBox = "0 0 24 24" } = $$props;
  let { ariaLabel = void 0 } = $$props;
  let { ariaHidden = void 0 } = $$props;
  let { title = void 0 } = $$props;
  let { desc = void 0 } = $$props;
  let { class: className = void 0 } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.width === void 0 && $$bindings.width && width !== void 0)
    $$bindings.width(width);
  if ($$props.height === void 0 && $$bindings.height && height !== void 0)
    $$bindings.height(height);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.viewBox === void 0 && $$bindings.viewBox && viewBox !== void 0)
    $$bindings.viewBox(viewBox);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0)
    $$bindings.ariaLabel(ariaLabel);
  if ($$props.ariaHidden === void 0 && $$bindings.ariaHidden && ariaHidden !== void 0)
    $$bindings.ariaHidden(ariaHidden);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0)
    $$bindings.desc(desc);
  if ($$props.class === void 0 && $$bindings.class && className !== void 0)
    $$bindings.class(className);
  return `<svg${add_attribute("viewBox", viewBox, 0)}${add_attribute("width", width, 0)}${add_attribute("height", height, 0)}${add_attribute("class", className, 0)}${add_attribute("aria-label", ariaLabel, 0)}${add_attribute("aria-hidden", ariaHidden, 0)}>${desc ? `<desc>${escape(desc)}</desc>` : ``}${title ? `<title>${escape(title)}</title>` : ``}<path d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1Z"${add_attribute("fill", color, 0)}></path></svg>`;
});
const Headset = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { size = "1em" } = $$props;
  let { width = size } = $$props;
  let { height = size } = $$props;
  let { color = "currentColor" } = $$props;
  let { viewBox = "0 0 24 24" } = $$props;
  let { ariaLabel = void 0 } = $$props;
  let { ariaHidden = void 0 } = $$props;
  let { title = void 0 } = $$props;
  let { desc = void 0 } = $$props;
  let { class: className = void 0 } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.width === void 0 && $$bindings.width && width !== void 0)
    $$bindings.width(width);
  if ($$props.height === void 0 && $$bindings.height && height !== void 0)
    $$bindings.height(height);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.viewBox === void 0 && $$bindings.viewBox && viewBox !== void 0)
    $$bindings.viewBox(viewBox);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0)
    $$bindings.ariaLabel(ariaLabel);
  if ($$props.ariaHidden === void 0 && $$bindings.ariaHidden && ariaHidden !== void 0)
    $$bindings.ariaHidden(ariaHidden);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0)
    $$bindings.desc(desc);
  if ($$props.class === void 0 && $$bindings.class && className !== void 0)
    $$bindings.class(className);
  return `<svg${add_attribute("viewBox", viewBox, 0)}${add_attribute("width", width, 0)}${add_attribute("height", height, 0)}${add_attribute("class", className, 0)}${add_attribute("aria-label", ariaLabel, 0)}${add_attribute("aria-hidden", ariaHidden, 0)}>${desc ? `<desc>${escape(desc)}</desc>` : ``}${title ? `<title>${escape(title)}</title>` : ``}<path d="M12,1C7,1 3,5 3,10V17A3,3 0 0,0 6,20H9V12H5V10A7,7 0 0,1 12,3A7,7 0 0,1 19,10V12H15V20H19V21H12V23H18A3,3 0 0,0 21,20V10C21,5 16.97,1 12,1Z"${add_attribute("fill", color, 0)}></path></svg>`;
});
const Tablet = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { size = "1em" } = $$props;
  let { width = size } = $$props;
  let { height = size } = $$props;
  let { color = "currentColor" } = $$props;
  let { viewBox = "0 0 24 24" } = $$props;
  let { ariaLabel = void 0 } = $$props;
  let { ariaHidden = void 0 } = $$props;
  let { title = void 0 } = $$props;
  let { desc = void 0 } = $$props;
  let { class: className = void 0 } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.width === void 0 && $$bindings.width && width !== void 0)
    $$bindings.width(width);
  if ($$props.height === void 0 && $$bindings.height && height !== void 0)
    $$bindings.height(height);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.viewBox === void 0 && $$bindings.viewBox && viewBox !== void 0)
    $$bindings.viewBox(viewBox);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0)
    $$bindings.ariaLabel(ariaLabel);
  if ($$props.ariaHidden === void 0 && $$bindings.ariaHidden && ariaHidden !== void 0)
    $$bindings.ariaHidden(ariaHidden);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0)
    $$bindings.desc(desc);
  if ($$props.class === void 0 && $$bindings.class && className !== void 0)
    $$bindings.class(className);
  return `<svg${add_attribute("viewBox", viewBox, 0)}${add_attribute("width", width, 0)}${add_attribute("height", height, 0)}${add_attribute("class", className, 0)}${add_attribute("aria-label", ariaLabel, 0)}${add_attribute("aria-hidden", ariaHidden, 0)}>${desc ? `<desc>${escape(desc)}</desc>` : ``}${title ? `<title>${escape(title)}</title>` : ``}<path d="M19,18H5V6H19M21,4H3C1.89,4 1,4.89 1,6V18A2,2 0 0,0 3,20H21A2,2 0 0,0 23,18V6C23,4.89 22.1,4 21,4Z"${add_attribute("fill", color, 0)}></path></svg>`;
});
const Sync = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { size = "1em" } = $$props;
  let { width = size } = $$props;
  let { height = size } = $$props;
  let { color = "currentColor" } = $$props;
  let { viewBox = "0 0 24 24" } = $$props;
  let { ariaLabel = void 0 } = $$props;
  let { ariaHidden = void 0 } = $$props;
  let { title = void 0 } = $$props;
  let { desc = void 0 } = $$props;
  let { class: className = void 0 } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.width === void 0 && $$bindings.width && width !== void 0)
    $$bindings.width(width);
  if ($$props.height === void 0 && $$bindings.height && height !== void 0)
    $$bindings.height(height);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.viewBox === void 0 && $$bindings.viewBox && viewBox !== void 0)
    $$bindings.viewBox(viewBox);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0)
    $$bindings.ariaLabel(ariaLabel);
  if ($$props.ariaHidden === void 0 && $$bindings.ariaHidden && ariaHidden !== void 0)
    $$bindings.ariaHidden(ariaHidden);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0)
    $$bindings.desc(desc);
  if ($$props.class === void 0 && $$bindings.class && className !== void 0)
    $$bindings.class(className);
  return `<svg${add_attribute("viewBox", viewBox, 0)}${add_attribute("width", width, 0)}${add_attribute("height", height, 0)}${add_attribute("class", className, 0)}${add_attribute("aria-label", ariaLabel, 0)}${add_attribute("aria-hidden", ariaHidden, 0)}>${desc ? `<desc>${escape(desc)}</desc>` : ``}${title ? `<title>${escape(title)}</title>` : ``}<path d="M12,18A6,6 0 0,1 6,12C6,11 6.25,10.03 6.7,9.2L5.24,7.74C4.46,8.97 4,10.43 4,12A8,8 0 0,0 12,20V23L16,19L12,15M12,4V1L8,5L12,9V6A6,6 0 0,1 18,12C18,13 17.75,13.97 17.3,14.8L18.76,16.26C19.54,15.03 20,13.57 20,12A8,8 0 0,0 12,4Z"${add_attribute("fill", color, 0)}></path></svg>`;
});
const BookOpenPageVariant = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { size = "1em" } = $$props;
  let { width = size } = $$props;
  let { height = size } = $$props;
  let { color = "currentColor" } = $$props;
  let { viewBox = "0 0 24 24" } = $$props;
  let { ariaLabel = void 0 } = $$props;
  let { ariaHidden = void 0 } = $$props;
  let { title = void 0 } = $$props;
  let { desc = void 0 } = $$props;
  let { class: className = void 0 } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.width === void 0 && $$bindings.width && width !== void 0)
    $$bindings.width(width);
  if ($$props.height === void 0 && $$bindings.height && height !== void 0)
    $$bindings.height(height);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.viewBox === void 0 && $$bindings.viewBox && viewBox !== void 0)
    $$bindings.viewBox(viewBox);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0)
    $$bindings.ariaLabel(ariaLabel);
  if ($$props.ariaHidden === void 0 && $$bindings.ariaHidden && ariaHidden !== void 0)
    $$bindings.ariaHidden(ariaHidden);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0)
    $$bindings.desc(desc);
  if ($$props.class === void 0 && $$bindings.class && className !== void 0)
    $$bindings.class(className);
  return `<svg${add_attribute("viewBox", viewBox, 0)}${add_attribute("width", width, 0)}${add_attribute("height", height, 0)}${add_attribute("class", className, 0)}${add_attribute("aria-label", ariaLabel, 0)}${add_attribute("aria-hidden", ariaHidden, 0)}>${desc ? `<desc>${escape(desc)}</desc>` : ``}${title ? `<title>${escape(title)}</title>` : ``}<path d="M19 2L14 6.5V17.5L19 13V2M6.5 5C4.55 5 2.45 5.4 1 6.5V21.16C1 21.41 1.25 21.66 1.5 21.66C1.6 21.66 1.65 21.59 1.75 21.59C3.1 20.94 5.05 20.5 6.5 20.5C8.45 20.5 10.55 20.9 12 22C13.35 21.15 15.8 20.5 17.5 20.5C19.15 20.5 20.85 20.81 22.25 21.56C22.35 21.61 22.4 21.59 22.5 21.59C22.75 21.59 23 21.34 23 21.09V6.5C22.4 6.05 21.75 5.75 21 5.5V19C19.9 18.65 18.7 18.5 17.5 18.5C15.8 18.5 13.35 19.15 12 20V6.5C10.55 5.4 8.45 5 6.5 5Z"${add_attribute("fill", color, 0)}></path></svg>`;
});
const ServicePageTemplate_svelte_svelte_type_style_lang = "";
const css = {
  code: "@media(min-width: 820px) and (max-width: 1024px){.mobile_rental.svelte-1m3iqbi.svelte-1m3iqbi{padding:0 8rem}}@media(max-width: 819px){.mobile_rental.svelte-1m3iqbi.svelte-1m3iqbi{padding:0 4rem}}.divider.svelte-1m3iqbi.svelte-1m3iqbi{margin:3.5rem}.hero.svelte-1m3iqbi.svelte-1m3iqbi{width:100%;height:90vh;padding:10rem 5rem;background-size:cover;background-repeat:no-repeat}.sections_wrapper.svelte-1m3iqbi.svelte-1m3iqbi{padding:10rem 13rem;display:flex;flex-direction:column;align-items:center;gap:7rem;overflow:hidden}@media(max-width: 800px){.sections_wrapper.svelte-1m3iqbi.svelte-1m3iqbi{padding:50px 5px}}.sections_wrapper.special.svelte-1m3iqbi.svelte-1m3iqbi{padding-top:0}@media(max-width: 800px){.sections_wrapper.special.svelte-1m3iqbi.svelte-1m3iqbi{padding:0 5px;gap:100px;gap:25px}}.orange_text.svelte-1m3iqbi.svelte-1m3iqbi{color:#f36d21;text-decoration:underline}.blue_text.svelte-1m3iqbi.svelte-1m3iqbi{color:#0e76bc;text-decoration:underline}.center_img.svelte-1m3iqbi.svelte-1m3iqbi{width:100%;max-width:100%;border-radius:4rem}.prereq_cards_wrapper.svelte-1m3iqbi.svelte-1m3iqbi{display:flex;justify-content:space-between;width:100%;margin-top:3rem;gap:0.5rem}@media(max-width: 1440px){.prereq_cards_wrapper.svelte-1m3iqbi.svelte-1m3iqbi{flex-direction:column;align-items:center;gap:2.5rem}}.bordered_card.svelte-1m3iqbi.svelte-1m3iqbi{padding:3.4rem 3rem;border-radius:2.6rem;width:33%;display:flex;flex-direction:column;gap:2rem}@media(max-width: 1440px){.bordered_card.svelte-1m3iqbi.svelte-1m3iqbi{width:100%}}.card_heading.svelte-1m3iqbi.svelte-1m3iqbi{text-transform:uppercase;font-weight:600;font-size:3.2rem;text-align:center;width:100%;padding:0.5rem 0}@media(max-width: 500px){.card_heading.svelte-1m3iqbi.svelte-1m3iqbi{font-size:2rem;padding:0.5rem 2rem}}.blue_background.svelte-1m3iqbi.svelte-1m3iqbi{background-color:#0e76bc}.orange_background.svelte-1m3iqbi.svelte-1m3iqbi{background-color:#f36d21}.blue_border.svelte-1m3iqbi.svelte-1m3iqbi{border:0.3rem solid #0e76bc}.orange_border.svelte-1m3iqbi.svelte-1m3iqbi{border:0.3rem solid #f36d21}ul.svelte-1m3iqbi.svelte-1m3iqbi{color:#15181c;font-size:1.6rem}li.svelte-1m3iqbi.svelte-1m3iqbi{padding:0.4rem}.icon_plane_flying_across_screen.svelte-1m3iqbi.svelte-1m3iqbi{width:100%;margin-left:-2rem}@media(max-width: 767px){.icon_plane_flying_across_screen.svelte-1m3iqbi.svelte-1m3iqbi{width:140rem}}.section.svelte-1m3iqbi.svelte-1m3iqbi{width:100%;display:flex;flex-direction:column;gap:3rem}.section.svelte-1m3iqbi .mobile_heading.svelte-1m3iqbi{margin-bottom:3rem}@media(max-width: 800px){.section.svelte-1m3iqbi .mobile_heading.svelte-1m3iqbi{margin-top:50px;margin-bottom:25px}}.pilot_programs.svelte-1m3iqbi.svelte-1m3iqbi{width:100vw;padding:0 5rem;overflow-x:scroll}@media(min-width: 1300px){.pilot_programs.svelte-1m3iqbi.svelte-1m3iqbi{overflow:hidden}}@media(min-width: 820px) and (max-width: 1024px){.pilot_programs.svelte-1m3iqbi.svelte-1m3iqbi{padding:0 13rem}}@media(max-width: 819px){.pilot_programs.svelte-1m3iqbi.svelte-1m3iqbi{padding:0 4rem}}.full_width.svelte-1m3iqbi.svelte-1m3iqbi{padding:9rem 8.3rem}.segments_wrapper.svelte-1m3iqbi.svelte-1m3iqbi{display:flex;flex-wrap:wrap;gap:1.4rem}.wider.svelte-1m3iqbi.svelte-1m3iqbi{padding:0 5rem}@media(max-width: 800px){.wider.svelte-1m3iqbi.svelte-1m3iqbi{padding:0 5px}}.mobile_hero.svelte-1m3iqbi.svelte-1m3iqbi{width:100%;background-color:#0e76bc;padding:10rem 5rem}",
  map: null
};
const ServicePageTemplate = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { faqs } = $$props;
  let { financing = true } = $$props;
  let { programs } = $$props;
  let { pricingPackage } = $$props;
  let { professionalProgram } = $$props;
  let { hero_image } = $$props;
  let { background_center } = $$props;
  let { h1 } = $$props;
  let { rentalRates = true } = $$props;
  let { hero_paragraph_content } = $$props;
  let { roadmap_stages } = $$props;
  let { center_img_seperating_section = false } = $$props;
  let { prerequisites } = $$props;
  let { second_center_img_seperating_section = false } = $$props;
  let things_included = [
    {
      text: "Written Tests",
      icon: TextBoxEditOutline
    },
    {
      text: "Checkride Fees",
      icon: CurrencyUsd
    },
    { text: "FAA Medical", icon: PlusThick },
    { text: "Renter's Insurance", icon: Shield },
    {
      text: "Pilot Training Kits",
      icon: BookOpenPageVariant
    },
    {
      text: "David Clark H10-13.4 Headset",
      icon: Headset
    },
    { text: "Ipad Mini", icon: Tablet },
    {
      text: "Foreflight Subscription",
      icon: Sync
    },
    {
      text: "Books and Materials",
      icon: BookOpenPageVariant
    }
  ];
  let window_width = 0;
  if ($$props.faqs === void 0 && $$bindings.faqs && faqs !== void 0)
    $$bindings.faqs(faqs);
  if ($$props.financing === void 0 && $$bindings.financing && financing !== void 0)
    $$bindings.financing(financing);
  if ($$props.programs === void 0 && $$bindings.programs && programs !== void 0)
    $$bindings.programs(programs);
  if ($$props.pricingPackage === void 0 && $$bindings.pricingPackage && pricingPackage !== void 0)
    $$bindings.pricingPackage(pricingPackage);
  if ($$props.professionalProgram === void 0 && $$bindings.professionalProgram && professionalProgram !== void 0)
    $$bindings.professionalProgram(professionalProgram);
  if ($$props.hero_image === void 0 && $$bindings.hero_image && hero_image !== void 0)
    $$bindings.hero_image(hero_image);
  if ($$props.background_center === void 0 && $$bindings.background_center && background_center !== void 0)
    $$bindings.background_center(background_center);
  if ($$props.h1 === void 0 && $$bindings.h1 && h1 !== void 0)
    $$bindings.h1(h1);
  if ($$props.rentalRates === void 0 && $$bindings.rentalRates && rentalRates !== void 0)
    $$bindings.rentalRates(rentalRates);
  if ($$props.hero_paragraph_content === void 0 && $$bindings.hero_paragraph_content && hero_paragraph_content !== void 0)
    $$bindings.hero_paragraph_content(hero_paragraph_content);
  if ($$props.roadmap_stages === void 0 && $$bindings.roadmap_stages && roadmap_stages !== void 0)
    $$bindings.roadmap_stages(roadmap_stages);
  if ($$props.center_img_seperating_section === void 0 && $$bindings.center_img_seperating_section && center_img_seperating_section !== void 0)
    $$bindings.center_img_seperating_section(center_img_seperating_section);
  if ($$props.prerequisites === void 0 && $$bindings.prerequisites && prerequisites !== void 0)
    $$bindings.prerequisites(prerequisites);
  if ($$props.second_center_img_seperating_section === void 0 && $$bindings.second_center_img_seperating_section && second_center_img_seperating_section !== void 0)
    $$bindings.second_center_img_seperating_section(second_center_img_seperating_section);
  $$result.css.add(css);
  return ` ${`<div class="mobile_hero svelte-1m3iqbi">${validate_component(FirstHeroContent, "FirstHeroContent").$$render($$result, { h1, hero_paragraph_content }, {}, {})}</div>`} <div class="sections_wrapper svelte-1m3iqbi">${slots.one ? slots.one({}) : ``}</div> <div class="sections_wrapper special svelte-1m3iqbi">${roadmap_stages ? `${validate_component(BorderedSection, "BorderedSection").$$render($$result, {}, {}, {
    default: () => {
      return `${validate_component(StdHeading, "MultiColoredHeading").$$render(
        $$result,
        {
          text_align: "center",
          underline: true,
          size: "large",
          color: "white"
        },
        {},
        {
          default: () => {
            return `<span class="orange_text svelte-1m3iqbi" data-svelte-h="svelte-140pfbq">Your</span><span class="blue_text svelte-1m3iqbi" data-svelte-h="svelte-ylejkj"> Roadmap</span>`;
          }
        }
      )} ${validate_component(StdParagraph, "StdParagraph").$$render(
        $$result,
        {
          color: "dark",
          text_align: "center",
          max_width: "50rem"
        },
        {},
        {
          default: () => {
            return `Aviation pathways can be very overwhelming, don&#39;t worry, we&#39;ll be with
        you every step of the way`;
          }
        }
      )} ${validate_component(Roadmap, "Roadmap").$$render($$result, { stages: roadmap_stages }, {}, {})}`;
    }
  })}` : ``} <div style="width: 100%;">${slots.two ? slots.two({}) : ``}</div> ${center_img_seperating_section ? `<img class="center_img svelte-1m3iqbi"${add_attribute(
    "src",
    center_img_seperating_section ? (
      // @ts-expect-error
      `${center_img_seperating_section.src}`
    ) : "",
    0
  )}${add_attribute(
    "alt",
    center_img_seperating_section ? (
      // @ts-expect-error
      `${center_img_seperating_section.alt}`
    ) : "",
    0
  )}>` : ``} ${slots.three ? slots.three({}) : ``} ${prerequisites ? `${validate_component(BorderedSection, "BorderedSection").$$render($$result, {}, {}, {
    default: () => {
      return `${validate_component(StdHeading, "MultiColoredHeading").$$render(
        $$result,
        {
          text_align: "center",
          underline: true,
          size: "large",
          color: "white"
        },
        {},
        {
          default: () => {
            return `<span class="orange_text svelte-1m3iqbi" data-svelte-h="svelte-tdlcfn">Checkride</span> ${`<br> <span class="blue_text svelte-1m3iqbi" data-svelte-h="svelte-yrvxve">Prerequisites</span>`}`;
          }
        }
      )} ${validate_component(StdParagraph, "StdParagraph").$$render(
        $$result,
        {
          color: "dark",
          text_align: "center",
          max_width: "50rem"
        },
        {},
        {
          default: () => {
            return `There&#39;s just a few things for you to check off before we can get your
        checkride scheduled`;
          }
        }
      )} <div class="prereq_cards_wrapper svelte-1m3iqbi"><div class="bordered_card blue_border svelte-1m3iqbi"><div class="card_heading blue_background svelte-1m3iqbi" data-svelte-h="svelte-h7k36c">Eligibility Requirements</div> <ul class="svelte-1m3iqbi">${each(prerequisites.eligibility, (requirement) => {
        return `<li class="svelte-1m3iqbi">${escape(requirement)}</li>`;
      })}</ul></div> <div class="bordered_card orange_border svelte-1m3iqbi"><div class="card_heading orange_background svelte-1m3iqbi" data-svelte-h="svelte-t2w89f">Flight <br> Proficiency</div> <ul class="svelte-1m3iqbi">${each(prerequisites.proficiency, (may_need_to_do) => {
        return `<li class="svelte-1m3iqbi">${escape(may_need_to_do)}</li>`;
      })}</ul></div> <div class="bordered_card blue_border svelte-1m3iqbi"><div class="card_heading blue_background svelte-1m3iqbi" data-svelte-h="svelte-cjgf1j">aeronautical experience</div> <ul class="svelte-1m3iqbi">${each(prerequisites.experience, (may_need_to_do) => {
        return `<li class="svelte-1m3iqbi"><!-- HTML_TAG_START -->${may_need_to_do}<!-- HTML_TAG_END --></li>`;
      })}</ul></div></div>`;
    }
  })}` : ``} ${second_center_img_seperating_section ? `<img class="center_img svelte-1m3iqbi"${add_attribute(
    "src",
    second_center_img_seperating_section ? (
      // @ts-expect-error
      `${second_center_img_seperating_section.src}`
    ) : "",
    0
  )}${add_attribute(
    "alt",
    second_center_img_seperating_section ? (
      // @ts-expect-error
      `${second_center_img_seperating_section.alt}`
    ) : "",
    0
  )}>` : ``} <img class="icon_plane_flying_across_screen svelte-1m3iqbi" src="/icon_plane_flying_across_screen.svg" alt="icon_plane_flying_across_screen"> ${programs ? `<div id="pricing" class="section pilot_programs svelte-1m3iqbi">${validate_component(StdHeading, "StdHeading").$$render($$result, { font_family: "Inter" }, {}, {
    default: () => {
      return `Pilot Programs`;
    }
  })} ${validate_component(ProgramPricing, "ProgramPricing").$$render($$result, {}, {}, {})}</div>` : ``}</div> ${professionalProgram ? `<div class="section full_width blue_background svelte-1m3iqbi" style="margin-bottom: 100px;">${validate_component(StdHeading, "StdHeading").$$render(
    $$result,
    {
      font_family: "Inter",
      color: "white",
      size: "small"
    },
    {},
    {
      default: () => {
        return `What&#39;s Included In The Professional Pilot Program?`;
      }
    }
  )} <div class="segments_wrapper svelte-1m3iqbi">${each(things_included, (thing_included) => {
    return `${validate_component(Segment, "Segment").$$render($$result, { icon: thing_included.icon }, {}, {
      default: () => {
        return `${escape(thing_included.text)} `;
      }
    })}`;
  })}</div></div>` : ``} <div class="section wider svelte-1m3iqbi">${rentalRates ? `<div class="mobile_rental svelte-1m3iqbi"><div class="mobile_heading svelte-1m3iqbi">${validate_component(StdHeading, "StdHeading").$$render($$result, { font_family: "Inter" }, {}, {
    default: () => {
      return `Rental &amp; Service Rates`;
    }
  })}</div> ${validate_component(RentalRates, "RentalRates").$$render($$result, {}, {}, {})}</div>` : ``} ${pricingPackage && !(window_width < 1440) ? `<div>${validate_component(StdHeading, "StdHeading").$$render($$result, { font_family: "Inter" }, {}, {
    default: () => {
      return `The Full Package`;
    }
  })}</div> ${validate_component(FullPackagePricing, "FullPackagePricing").$$render($$result, {}, {}, {})}` : ``}</div> <div class="divider svelte-1m3iqbi" style="margin-top: 50px;"></div> ${financing ? `${validate_component(FinancingCard, "FinancingCard").$$render($$result, {}, {}, {})}` : ``} <div class="divider svelte-1m3iqbi"></div> ${validate_component(DiscoveryFlightSection, "DiscoveryFlightSection").$$render($$result, {}, {}, {})} ${faqs ? `${validate_component(FAQs, "FAQs").$$render($$result, { faqs }, {}, {})}` : ``} ${validate_component(Reviews, "Reviews").$$render($$result, {}, {}, {})} ${validate_component(ContactUsSection, "ContactUsSection").$$render($$result, {}, {}, {})}`;
});
export {
  BookOpenPageVariant as B,
  CurrencyUsd as C,
  Headset as H,
  PlusThick as P,
  ServicePageTemplate as S,
  TextBoxEditOutline as T,
  Shield as a,
  Tablet as b,
  Sync as c
};
